import React, { useState } from "react";
import mock0 from '../assets/images/mock0.png';
import mock00 from '../assets/images/mock00.png';
import mock01 from '../assets/images/mock01.png';
import mock03 from '../assets/images/mock03.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import foxxThumb from '../assets/images/foxx-thumb.svg';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import '../assets/styles/Project.scss';

type ProjectItem = {
    title: string;
    href: string;
    img: any;
    alt?: string;
    desc?: string;
    featured?: boolean;
};

function Project() {
    const [showAll, setShowAll] = useState<boolean>(false);
    const visibleCount = 6;

    const projects: ProjectItem[] = [
        { title: 'Sellu AI', href: 'https://sellu.ai/', img: mock0, alt: 'Sellu AI', desc: 'Sellu remembers every call, text, and email — forever. And it learns.', featured: true },
        { title: 'RankHigh on AI', href: 'https://www.rankhighonai.com/', img: mock00, alt: 'RankHigh on AI', desc: 'Know exactly where your company ranks across ChatGPT, Grok AI, and Microsoft Co-Pilot.', featured: true },
        { title: 'Tlento for HR', href: 'https://kazzicom.tlento.com/', img: mock10, alt: 'Tlento for HR', desc: 'HR software using Django and Python.', featured: true },
        { title: 'Gym Online Payment Service', href: 'https://24hr-fitness.eu', img: mock09, alt: 'Gym Online Payment Service', desc: 'Gym Online Payment Service and API using WP-plugin', featured: true },
        { title: 'Gym Local app to control the AI gate', href: 'https://24hr-fitness.eu', img: mock08, alt: 'Gym Local app to control the AI gate', desc: 'Face detection local app using C# & IoT', featured: true },
        { title: 'Membership Management', href: 'https://gymsys.eu', img: mock05, alt: 'Membership Management', desc: 'Sale & Membership management website using PHP', featured: false },
        { title: 'WeManage: Real Estate Asset Management', href: 'https://play.google.com/store/apps/details?id=com.xtfhrfitness.gymaccess', img: mock06, alt: 'WeManage: Real Estate Asset Management', desc: 'Mobile app for Gym Owner. This app is built with React Native.', featured: false },
        { title: 'E-commerce API', href: 'http://159.89.113.135', img: mock03, alt: 'E-commerce API', desc: 'E-commerce API using NodeJS/VueJS', featured: false },
        { title: 'Game Development Service', href: 'https://player1.win', img: mock07, alt: 'Game Development Service', desc: 'Interactive and engaging online games using HTML Canvas using ExpressJS and socket.io', featured: false },
        { title: 'Education online service', href: 'https://en.simplevisor.ch/', img: mock01, alt: 'Education online service', desc: 'Education webservice for the parents using MEAN Stack and IONIC5', featured: false },
    ];

    const visibleProjects = showAll ? projects : projects.slice(0, visibleCount);

    return (
        <div className="projects-container" id="projects">
            <h1>Projects</h1>
            <div className="projects-grid">
                {visibleProjects.map((p) => (
                    <div key={p.title} className={`project ${p.featured ? 'featured' : ''}`}>
                        <a href={p.href} target="_blank" rel="noreferrer"><img src={p.img} className="zoom" alt={p.alt} width="100%"/></a>
                        <a href={p.href} target="_blank" rel="noreferrer"><h2>{p.title}</h2></a>
                        <p>{p.desc}</p>
                    </div>
                ))}
            </div>

            {projects.length > visibleCount && (
                <div className="more-container">
                    <button className="more-button" onClick={() => setShowAll(s => !s)}>{showAll ? 'Less' : 'More'}</button>
                </div>
            )}
        </div>
    );
}

export default Project;